// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.

import { advisoryApi } from '@shared/data-access/api/brokerage/advisory-api';
import { useMemo } from 'react';

/** Shared proposals query for Silver Alpha availability and Home content. */
export const useSilverAlphaProposals = () => {
  const {
    data: proposals = [],
    isLoading,
    isFetching,
    isSuccess,
    isError,
  } = advisoryApi.useGetAdvisoryProposalsQuery();

  const hasProposals = proposals.length > 0;

  const pendingProposals = useMemo(
    () => proposals.filter(proposal => proposal.status === 'pending'),
    [proposals],
  );

  const hasActiveProposal = useMemo(
    () => proposals.some(proposal => proposal.status === 'active'),
    [proposals],
  );

  return {
    proposals,
    pendingProposals,
    hasProposals,
    hasActiveProposal,
    isLoading,
    isFetching,
    isSuccess,
    isError,
  };
};
